export default __webpack_public_path__ + "static/media/1-1-1.ff9d6185.jpg";